import Ipsa from './Ipsa'

export default Ipsa
